import { type Relationship, relationshipSchema } from "@/schemas";
import { filteredArray } from "@/schemas/utils";

import { QueryKeys } from "../../query-keys";
import { importEntities } from "../index";

/**
 * Import relationships to the global cache.
 *
 * @param relationships - array of Relationships
 */
function importRelationships(relationships: Relationship[]) {
  const parsedResult =
    filteredArray(relationshipSchema).safeParse(relationships);
  if (parsedResult.success) {
    importEntities(QueryKeys.relationships.global, parsedResult.data);
  }
}

export { importRelationships };
